<app-iota-modal [modalOptions]="modalOptions" (close$)="close()">
    <h5 modal-header i18n>Manage {{ (companyProductSelection$ | ngrxPush)?.name }}</h5>
    <div modal-body class="flex flex-col gap-2">
        <a
            class="btn btn-secondary max-w-md"
            [routerLink]="'/administration/product/' + (companyProductSelection$ | ngrxPush)?.infinkonProductId"
            matDialogClose
            i18n
        >
            Open product
        </a>
        <div class="divider"></div>
        <app-product-pricing-option-list
            [companyId]="selectedCompanyId$ | ngrxPush"
            [productId]="data.productId"
            [companyProductSelection]="companyProductSelection$ | ngrxPush"
            [priceScaleState]="priceScaleState$ | ngrxPush"
        >
        </app-product-pricing-option-list>
        <app-section-header>
            <ng-container buttons>
                <button *ngIf="!editMode" (click)="edit()">
                    <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
                </button>
                <button *ngIf="editMode" class="btn btn-accent" (click)="save()">
                    <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
                </button>
                <button *ngIf="editMode" class="btn btn-accent" (click)="cancel()">
                    <iota-icon icon="x-mark"></iota-icon>
                </button>
            </ng-container>
        </app-section-header>
        <app-attribute-list-v2
            [attributes]="(companyProductSelection$ | ngrxPush)?.attributes"
            scope="PRODUCT"
            [productCategory]="(companyProductSelection$ | ngrxPush)?.productDetails?.category"
            [parentId]="(companyProductSelection$ | ngrxPush).companyProductSelectionId"
            [editMode]="editMode"
            [markIfParentIdIsThisParentId]="true"
            [showNumberOfAttributesWithThisParentIdBadge]="true"
            [additionalInformationTemplate]="additionalInformationTemplate"
            numberOfAttributesWithThisParentIdBadgeSuffix="company-specific"
            i18n-numberOfAttributesWithThisParentIdBadgeSuffix
            overridesOtherAttributeTooltip="Overrides attribute on the product"
            i18n-overridesOtherAttributeTooltip
            parentIdIsThisParentIdTooltip="Specific to this company"
            i18n-parentIdIsThisParentIdTooltip
            #attributeList
        >
            <ng-template #additionalInformationTemplate>
                <span i18n
                    >The attributes shown here are the attributes of the product. If an attribute is overwritten by a company-specific
                    attribute, it is <span class="text-accent underline">marked</span> in the list.
                </span>
            </ng-template>
        </app-attribute-list-v2>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
    </div>
</app-iota-modal>
